<template>
  <div class="graph-wrapper">

    <p class="title">{{ title }}</p>

    <div class="chart-wrapper">

      <chart :options="value"/>

    </div>

  </div>
</template>

<script>
import Chart from './components';

export default {
  name: 'ChartComponent',
  props: {
    title: {
      type: String,
      default: '타이틀',
    },

    value: {
      type: Object,
      isRequired: true,
    },
  },
  components: {
    Chart,
  },
  data() {
    return {
      data: this.chartData,
    };
  },
};
</script>

<style lang="scss" scoped>
.graph-wrapper {
  width: 100%;
  height: 100%;

  padding: 24px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-content: center;

  max-width: 1024px;

  background-color: rgb(255, 255, 255);
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);

  .title {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 600;
  }

  .chart-wrapper {
    width: 100%;
    height: 100%;
  }
}
</style>

<style lang="scss" src="./chart.scss"></style>



// WEBPACK FOOTER //
// src/modules/chart/ChartComponent.vue